import type { InferType } from 'yup'
import { object, string } from 'yup'

export const PV1PrescriberEditFormSchema = object().shape({
  prescriber: string().required().label('Prescriber'),
  address: string().required().label('Address'),
})

export type PV1PrescriberEditFormSchemaType = InferType<typeof PV1PrescriberEditFormSchema>
